import { gql } from '@apollo/client'

export const TENANTS_QUERY = gql`
  query Tenants($showLog: Boolean) {
    tenants(showLog: $showLog) {
      basicDetails {
        name
        tenantCode
        displayTenantCode
        tenantId
      }
    }
  }
`

export const TENANT_QUERY = gql`
  query Tenant($tenantId: String, $tenantCode: Int) {
    tenant(tenantId: $tenantId, tenantCode: $tenantCode) {
      basicDetails {
        name
        hostName
        slogan
        tenantCode
        displayTenantCode
        tenantId
      }
      WBSDetails {
        bookingRedirectLink
      }
    }
  }
`

export const TENANT_NAME_QUERY = gql`
  query TenantName($tenantId: String, $tenantCode: Int) {
    tenantName(tenantId: $tenantId, tenantCode: $tenantCode) {
      basicDetails {
        name
        tenantCode
        displayTenantCode
        tenantId
      }
    }
  }
`

export const ITTIC_REERVATION_TYPES = gql`
  query GetItticReservationTypes($tenantCode: Int!) {
    getItticReservationTypes(tenantCode: $tenantCode) {
      ID
      code
      name {
        fa
        en
      }
    }
  }
`

export const START_TENANT_DATA_EXPORT_MUTATION = gql`
  mutation StartTenantDataExport($input: TenantDataExportInput!) {
    startTenantDataExport(input: $input) {
      artifactId
      status
      datasets {
        domain
        dataset
        rowCount
      }
    }
  }
`

export const START_TENANT_DATA_EXPORT_V2_MUTATION = gql`
  mutation StartTenantDataExportV2($input: TenantDataExportV2Input!) {
    startTenantDataExportV2(input: $input) {
      artifactId
      status
      profile
      contractVersion
      schemaVersion
      includePersonalData
      datasets {
        domain
        dataset
        rowCount
      }
    }
  }
`

export const TENANT_DATA_EXPORT_JOB_QUERY = gql`
  query TenantDataExportJob($artifactId: String!) {
    tenantDataExportJob(artifactId: $artifactId) {
      profile
      contractVersion
      schemaVersion
      includePersonalData
      artifactId
      status
      error
      failureCode
      artifactSize
      expiresAt
      datasets {
        domain
        dataset
        rowCount
      }
    }
  }
`

export const TENANT_DATA_EXPORT_JOBS_QUERY = gql`
  query TenantDataExportJobs($tenantId: String!, $limit: Int) {
    tenantDataExportJobs(tenantId: $tenantId, limit: $limit) {
      profile
      contractVersion
      schemaVersion
      includePersonalData
      artifactId
      status
      error
      failureCode
      artifactSize
      expiresAt
      datasets {
        domain
        dataset
        rowCount
      }
    }
  }
`

export const DOWNLOAD_TENANT_DATA_EXPORT_QUERY = gql`
  query DownloadTenantDataExport($artifactId: String!) {
    downloadTenantDataExport(artifactId: $artifactId) {
      artifactId
      fileName
      content
    }
  }
`
